<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <div v-if="props.row.type" slot="type" slot-scope="props">

          <span v-if="props.row.type == 'Virement'" class="badge badge-success p-2">{{ props.row.type }}</span>
          <span v-else-if="props.row.type == 'Télérèglement'" class="badge badge-primary p-2">{{ props.row.type }}</span>
          <span v-else-if="props.row.type == 'Chèque'" class="badge badge-warning p-2">{{ props.row.type }}</span>
      </div>
      <div v-if="props.row.montant" slot="montant" slot-scope="props" class="slot-number text-nowrap">
        <span>{{ formatNumber(props.row.montant) }}</span>
      </div>
      <div v-if="props.row.date_execution" slot="date_execution" slot-scope="props" class="slot-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_execution) }}</span>
      </div>
      <div v-if="props.row.reference1" slot="reference1" slot-scope="props">
        <span>{{ props.row.reference1 }}</span>
      </div>


      <div v-if="props.row.reference2" slot="reference2" slot-scope="props">
        <span :id="'identifiant-tooltip-ref2-' + props.row.montant + '-' + props.row.siren +  '-' + props.row.date_execution">{{ props.row.reference2.substring(0,10) }}</span>
        <b-tooltip :target="'identifiant-tooltip-ref2-' + props.row.montant + '-' + props.row.siren +  '-' + props.row.date_execution" triggers="hover" placement="top">{{ props.row.reference2 }}</b-tooltip>
      </div>

      <div v-if="props.row.reference3" slot="reference3" slot-scope="props">
        <span :id="'identifiant-tooltip-ref3-' + props.row.montant + '-' + props.row.siren +  '-' + props.row.date_execution">{{ props.row.reference3.substring(0,10) }}</span>
        <b-tooltip :target="'identifiant-tooltip-ref3-' + props.row.montant + '-' + props.row.siren +  '-' + props.row.date_execution" triggers="hover" placement="top">{{ props.row.reference3 }}</b-tooltip>
      </div>

      <div v-if="props.row.reference4" slot="reference4" slot-scope="props">
        <span :id="'identifiant-tooltip-ref4-' + props.row.montant + '-' + props.row.siren +  '-' + props.row.date_execution">{{ props.row.reference4.substring(0,10) }}</span>
        <b-tooltip :target="'identifiant-tooltip-ref4-' + props.row.montant + '-' + props.row.siren +  '-' + props.row.date_execution" triggers="hover" placement="top">{{ props.row.reference4 }}</b-tooltip>
      </div>


      <div v-if="props.row.siren" slot="siren" slot-scope="props" class="slot-number">
        <span v-if="props.row.siren == 'KO' "></span>
        <span v-else>{{ props.row.siren.substring(0,9) }}</span>
      </div>

      <div v-if="props.row.statut" slot="statut" slot-scope="props">
          <span v-if="props.row.statut == 'Traité'" class="badge badge-success p-2">Encaissé sur NSI</span>
          <span v-else-if="props.row.statut == 'Encaissé'" class="badge badge-success p-2">Encaissé sur NSI</span>
          <span v-else-if="props.row.statut == 'Encaissé avec non-ventilé'" class="badge badge-success p-2">Encaissé sur NSI</span>
          <span v-else-if="props.row.statut == 'Neutralisé'" class="badge badge-secondary p-2">{{ props.row.statut }}</span>
          <span v-else-if="props.row.statut == 'En cours de traitement'" class="badge badge-warning p-2">Non encaissé sur NSI</span>
          <span v-else-if="props.row.statut == 'En attente de traitement'" class="badge badge-warning p-2">Non encaissé sur NSI</span>
          <span v-else-if="props.row.statut == 'En attente d\'envoi à la banque'" class="badge badge-warning p-2">Non encaissé sur NSI</span>
          <span v-else class="badge badge-danger p-2">{{ props.row.statut }}</span>
      </div>

      <div v-if="props.row.numero_tp" slot="numero_tp" slot-scope="props">
        <span>{{ props.row.numero_tp }}</span>
      </div>
      <div v-if="props.row.gestionnaire" slot="gestionnaire" slot-scope="props">
        <span>{{ props.row.gestionnaire }}</span>
      </div>
      <div slot="action" slot-scope="props">
        <b-button type="button" @click.prevent="deleteReglement(props.row.type, props.row.id)" class="badge badge-danger mr-3 p-2" :disabled="!canAccess(rules.MANAGE_RPA_DATA)">
          <i class="fa fa-remove"></i> Supprimer
        </b-button>
        <b-button type="button" @click="editReglement(props.row.type, props.row.id)" class="badge badge-primary p-2" :disabled="!canAccess(rules.MANAGE_RPA_DATA)">
          <i class="fa fa-edit"></i> Modifier
        </b-button>
      </div>

    </v-server-table>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "../../utils/auth";
import {espaceRPARules, hasRule} from '../../utils/rulesHelper';

export default {
  name: "ReglementTable",
  props: ["tableEntry"],
  data() {
    let self = this;
    return {
      rules: espaceRPARules,
      url: '',
      columns: [
        "type",
        "montant",
        "date_execution",
        "reference1",
        "reference2",
        "reference3",
        "reference4",
        "siren",
        "statut",
        "numero_tp",
        "gestionnaire",
        "action",
      ],
      items: [],
      options: {
        headings: {
          type: "Type",
          montant: "Montant",
          date_execution : "Date exec.",
          reference1: "Réference 1",
          reference2: "Réference 2",
          reference3: "Réference 3",
          reference4: "Réference 4",
          siren: "SIREN",
          statut: "Statut",
          numero_tp: "Num. TP",
          gestionnaire: "Gestionnaire",
          action: "Action",
        },
        sortable: ["date_execution"],
        //filterable: ["montant", "date_execution", "siren", "numero_tp"],
        filterable: false,
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "Montant, Date, Siren, TP"
        },
        orderBy: { ascending: true},
        requestFunction: function (data) {
            self.url = '/espaceRPA/reglements/search'
            data["type"] = self.tableEntry.type;
            data["montant"] = self.tableEntry.montant;
            data["precision"] = self.tableEntry.precision;
            data["texte"] = self.tableEntry.texte;
            data["siren"] = self.tableEntry.siren;
            data["date_du"] = self.tableEntry.date_du;
            data["date_au"] = self.tableEntry.date_au;
            data["noSearch"] = self.$parent.noSearch;

            self.$store.commit("IS_LOADING", true);

            return axios.get(self.url, {
                params: data
            })
            .catch(function (e) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
        }
      }
    };
  },
  methods: {
    onLoaded(){
      this.$store.commit("IS_LOADING", false);
    },
    formatNumber(num) {
      if(num != null){
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ").replace(/\./g, ',');
      }
    },
    formatDate(textDate) {
      return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
    },
    editReglement(type,id) {
      type = type.replace(/é/g, "e");
      type = type.replace(/è/g, "e");
      this.$router.push({ path: `/suivi-cotisations/reglements/edit-reglement/${id}`, query: { type: type.toLowerCase() }});
    },
    deleteReglement(type, id) {
      type = type.replace(/é/g, "e");
      type = type.replace(/è/g, "e");
      let self = this;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer ce règlement ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
      }).then((result) => {
        if (!result.value) {
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post(`/espaceRPA/reglements/delete/${type.toLowerCase()}/${id}`)
            .then(response => {
              this.$refs.table.refresh();
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'success',
                title:'Suppression avec succès',
                text:'Le règlement a bien été supprimé',
                showConfirmButton: false,
                timer: 5000
              });
            })
            .catch(function(error){
              this.$refs.table.refresh();
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'warning',
                title:'Attention !!',
                text:'Un problème est survenu, merci de contacter l\'administrateur',
                showConfirmButton: false,
                timer: 5000
              });
            })
        }
      })
    },
    canAccess(rule) {
      return hasRule(rule)
    },
  }
};
</script>

<style scoped>
.VueTables__search-field input {
  width: 240px !important;
}
</style>
